import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Scores } from './ScoreIcon';
import { Emoji } from './icons/emoji';
import { Number } from './icons/number';
import { Star } from './icons/star';
export const AllIcons = ({ scoreIconStyle, size, score: selectedScore, }) => {
    return (_jsx(_Fragment, { children: Scores.map((score) => {
            switch (scoreIconStyle) {
                case 'stars':
                    return (_jsx(Star, { score: score, size: size, isSelected: score <= selectedScore }, `star-${score}`));
                case 'numbers':
                    return (_jsx(Number, { score: score, size: size, isSelected: score <= selectedScore }, `number-${score}`));
                case 'emojis':
                default:
                    return (_jsx(Emoji, { score: score, size: size, isSelected: score === selectedScore }, `emoji-${score}`));
            }
        }) }));
};
